module.exports = __webpack_public_path__ + "officialStatic/img/zhejiangligongLogo.9da02e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/zhejiangligongLogo.png
// module id = N3zg
// module chunks = 0